package hk.com.vr360_demo2.webapp.core.net.common

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class SceneInfo(
    val id: String = "",
    val url: String = "",
    val name: String = "",
//    val levels: List<LevelInfo> = emptyList(),
    val faceSize: Int = 4096,
    val initialViewParameters: SceneInitViewParameters? = SceneInitViewParameters(0.0, 0.0, 0.0),
    val linkHotspots: List<SceneLinkHot>? = emptyList(),
//    val infoHotspots: List<JsonObject> = emptyList(),
    val cover: String = "",
    val tilesUrl: String = ""
)

@Serializable
data class SceneInitViewParameters(
    val yaw: Double? = null,
    val pitch: Double? = null,
    val fov: Double? = null,
) {
}

@Serializable
data class SceneLinkHot(
    val yaw: Double,
    val pitch: Double,
    val target: String,
    val rotation: Double? = null,
    val imageName: String? = null,
)

@Serializable
// 公司和經紀人信息
// 對應後端 JSON 字段
// "companyLogo": "...",
// "photoUrl": "...",
// "userName": "...",
// "licenseNo": "...",
// "mobile": "..."
data class PropertyInfo(
    val companyLogo: String? = null,
    val photoUrl: String? = null,
    val userName: String? = "",
    val licenseNo: String? = "",
    val mobile: String? = "",
    val title: String? = "",
    val companyName: String? = "",
    val uid: String? = null,

    )

@Serializable
data class PanoramaDataJsonResult(
    val modelInfoList: List<SceneInfo>? = null,
    val vRlinkerBO: PropertyInfo? = null,
    val title: String? = null,
    val cover: String? = null,
    val uid: Int? = null,
    val version: Int? = null
)

@Serializable
data class PanoramaEditData(
    val scenes: List<SaveSceneInfo>
)


@Serializable
data class SaveResult(
    val code: Int,
    val message: String? = null,
    val data: JsonObject? = null
)

@Serializable
data class SaveSceneInfo(
    val id: String = "",
    val initialViewParameters: SceneInitViewParameters? = SceneInitViewParameters(0.0, 0.0, 0.0),
    val linkHotspots: List<SceneLinkHot>? = emptyList(),
)